export interface Locale {
  readonly code: string;
  readonly label: string;
  readonly short: string;
}

export const DEFAULT_LOCALES: readonly Locale[] = [
  { code: 'fr-FR', label: 'Français', short: 'FR' },
  { code: 'en-US', label: 'English', short: 'EN' },
  { code: 'es-MX', label: 'Español', short: 'ES' },
];
